import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isAdmin, isSystemAdmin } from '../../features/profile';
import { DashboardNavCard, DashboardPageHeader } from '../../shared/ui';
import './DashboardSettingsPage.css';

const DashboardSettingsPage: React.FC = () => {
  const { profile } = useAuth();

  if (!isAdmin(profile)) {
    return <Navigate to="/dashboard" replace />;
  }

  const showPermissions = isSystemAdmin(profile);

  return (
    <div className="container-fluid px-3 px-md-4 dashboard-settings-page">
      <DashboardPageHeader
        title="Settings"
        description="Administrative tools for your account. Open a section below to manage permissions, monitor traffic, or check system status."
        icon="bi bi-gear"
      />

      <div
        className={
          showPermissions
            ? 'row g-4 row-cols-1 row-cols-md-2 row-cols-xl-3'
            : 'row g-4 row-cols-1 row-cols-md-2'
        }
      >
        {showPermissions && (
          <div className="col">
            <DashboardNavCard
              title="Role permissions"
              description="Configure per-feature access (view, edit, delete, admin) for each role. The system ADMIN role always has full access."
              to="/dashboard/settings/permissions"
              actionLabel="Open permissions"
              icon="bi-shield-lock"
            />
          </div>
        )}
        <div className="col">
          <DashboardNavCard
            title="Traffic and analytics"
            description="Unique anonymous visitors and top paths on the public site (UTC). Admin only."
            to="/dashboard/traffic"
            actionLabel="Open traffic"
            icon="bi-graph-up-arrow"
          />
        </div>
        <div className="col">
          <DashboardNavCard
            title="System health"
            description="Database readiness, 30-day critical issue trends, and the latest issues log. Admin only."
            to="/dashboard/system-health"
            actionLabel="Open system health"
            icon="bi-heart-pulse"
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardSettingsPage;
